module.exports = __webpack_public_path__ + "img/imagen3.f951e4a9.png";